<script>
  // Extensions
  import View from '@/views/View'

  // Mixins
  import LoadSections from '@/mixins/load-sections'

  export default {
    name: 'ContactUs',

    metaInfo: {
      title: 'Contact Us',
      meta: [
        { vmid: 'description', name: 'description', content: 'Contact YOOXPLORE – get in touch for inquiries about our UAV systems, anti-jamming modules, partnership opportunities, and business cooperation.' },
        { vmid: 'keywords', name: 'keywords', content: 'YOOXPLORE, contact us, UAV inquiry, drone quotation, anti-jamming module, partnership inquiry, customer service' },
      ],
    },

    extends: View,

    mixins: [
      LoadSections([
        'hero-alt',
        'keep-in-touch2',
        // 'map',
        // 'newsletter-alt',
      ]),
    ],

    props: {
      id: {
        type: String,
        default: 'about',
      },
    },
  }
</script>
